module.exports = Jsw.skinUrl + "/icons/16/plesk/file-audio.png?72fe25f83d67048d40e6c86149d696bf";